import './styles/index.scss';
import AmplifyBot from './AmplifyBot'
import ChatBot from './ChatBot'
import hasOwn from 'object.hasown'

if (!Object.hasOwn) {
	hasOwn.shim();
}

export * from './common/';
export * from './ChatBot/components/feed';
export * from './ChatBot/components/message';
export {
    AmplifyBot
}

export default ChatBot